// This icon file is generated automatically.
var RestoreOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 1024 1024", "focusable": "false" }, "children": [{ "tag": "defs", "attrs": {}, "children": [{ "tag": "style", "attrs": {} }] }, { "tag": "path", "attrs": { "d": "M890.83 166.18a21.41 21.41 0 00-30.29-30.27L597.61 398.88V193.81a21.4 21.4 0 00-42.81.01v256.71a21.49 21.49 0 0021.4 21.4h256.7a21.4 21.4 0 100-42.8H627.85l262.98-262.95zm-421.6 669.53V579a21.48 21.48 0 00-21.38-21.4H191.12a21.41 21.41 0 00-21.4 21.4 21.42 21.42 0 0021.41 21.4H396.2L133.22 863.33a21.4 21.4 0 000 30.28 21.39 21.39 0 0030.28 0l262.96-262.97v205.08a21.39 21.39 0 1042.78-.02z" } }] }, "name": "restore", "theme": "outlined" };
export default RestoreOutlined;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons-svg/es/asn/RestoreOutlined.js
// module id = 4006
// module chunks = 0